import { useState, useEffect } from 'react';
import './scss/custom.scss';
import 'typeface-roboto';

import Initiate from './pages/Initiate';
import Dashboard from './pages/Dashboard';
import PortalDataService from './services/portal.service';
import StateContext from './context/State';
import { useAppSelector } from '../../redux/hooks';
import { RPWDataReader, getDataReader } from '../../livedataFuncs';
import { StateTypeContext } from './types';
import InitalLoadingComponent from './components/InitalLoadingComponent';
import { lddStateObject, setClientPortalModalType, setClientPortalPage } from '../../redux/reducer';
import DocumentExchange from './pages/Dashboard/Documents'
import ManageSession from './pages/Dashboard/ConfigureSigning'
import { DefaultClientPortalState } from './data';
import ClientTasks from './pages/Dashboard/ClientTasks';


const App = () => {
    const [state, setState] = useState<StateTypeContext>(DefaultClientPortalState);
    const lawyerService = new PortalDataService(state);
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const processor: RPWDataReader = getDataReader(livedataRootContainer?.dataRoot);
    const clientPortalPage = useAppSelector((state) => state.ClientPortalState?.PageName);

    useEffect(() => {
        if (state.portalId !== 0) {
            let page = 0;
            switch (clientPortalPage) {
                case "ClientIntake":
                    page = 1;
                    break;
                case "DocumentExchange":
                    page = 2;
                    break;
                case "esigning":
                    page = 3;
                    break;
                default:
                    page = 1;
            }
            setState({ ...state, page })
        }
        // eslint-disable-next-line
    }, [clientPortalPage])

    useEffect(() => {
        if (livedataRootContainer?.dataRoot) {
            const appId = processor.getAppId();
            setState({
                page: 4,
                portalId: 0,
                appId: appId,
                processor,
                appCode: ''
            });

            lawyerService.getPortalByAppId(appId)
                .then((existingPortal) => {
                    if (existingPortal.length > 0) {
                        setState({
                            page: 1,
                            portalId: existingPortal[0].Id,
                            appId: appId,
                            processor,
                            appCode: ''
                        });
                    } else {
                        setState({
                            page: 0,
                            portalId: 0,
                            appId: appId,
                            processor,
                            appCode: ''
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                })
        }
        // eslint-disable-next-line
    }, [livedataRootContainer]);

    return (
        <>
            <div style={{ overflow: 'auto', height: '100%' }}>
                <StateContext.Provider value={{ state, setState }}>
                    {state.portalId !== 0 && <ClientTasks />}
                    {!state.page && <Initiate />}
                    {state.page === 1 && <Dashboard />}
                    {state.page === 2 && <DocumentExchange />}
                    {state.page === 3 && <ManageSession />}
                    {state.page === 4 && <InitalLoadingComponent />}
                </StateContext.Provider>
            </div>
        </>
    );
}

export const ClientPortalModalDispatch = (dispatch, modalType) => {
    dispatch(setClientPortalModalType(modalType))
}

export const ClientPortalPageDispatch = (dispatch, page) => {
    dispatch(setClientPortalPage(page));
}

export default App;
